export default __webpack_public_path__ + "bml-module4671a4.png";